// Outbound links and CTA tracking for the home page.

import { trackEvent } from '../../analytics';

export const APP_STORE_URL = 'https://apps.apple.com/us/app/burst-fitness/id6739505525';
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.burst.fitness';
export const SUPPORT_EMAIL = 'hello@burst-athletics.com';

// Left empty until the Burst Instagram URL is confirmed; the footer link is
// only rendered when this has a value.
export const INSTAGRAM_URL = '';

export type StorePlatform = 'ios' | 'android';
export type CtaLocation = 'nav' | 'hero' | 'pricing' | 'menu';

export function trackStoreClick(platform: StorePlatform, location: CtaLocation) {
  trackEvent('store_cta_click', { platform, location });
}
